import { PlusOutlined } from '@ant-design/icons';
import { translate, TranslationEntity } from '@repo/utils';
import { type NodeProps, Position } from '@xyflow/react';
import { Flex, Popover, Typography } from 'antd';
import CreateAutomationNodeMenu from 'automations/components/CreateAutomationNodeMenu';
import CreateTriggerMenu from 'automations/components/CreateTriggerMenu';
import NodeHandler from 'automations/components/NodeHandler';
import { isTriggerNodePresentSelector } from 'automations/selectors/reactFlow';
import { type EmptyNodeType } from 'automations/types/nodeTypes';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import styles from './NewBlockNode.module.scss';

export default function NewBlockNode({
  id,
  positionAbsoluteX,
  positionAbsoluteY,
  data,
}: NodeProps<EmptyNodeType>) {
  const isTriggerNodePresent = useSelector(isTriggerNodePresentSelector);

  const [open, setOpen] = useState(false);

  const handleVisibleChange = useCallback((visible: boolean) => {
    setOpen(visible);
  }, []);

  const isNodeForTriggerNode = !isTriggerNodePresent;

  return (
    <>
      {isNodeForTriggerNode && (
        <CreateTriggerMenu
          nodeId={id}
          open={open}
          setOpen={setOpen}
        />
      )}
      <Popover
        open={open && !isNodeForTriggerNode}
        onOpenChange={handleVisibleChange}
        overlayInnerStyle={{ padding: 0 }}
        content={(
          <CreateAutomationNodeMenu
            handleVisibleChange={handleVisibleChange}
            nodeId={id}
            defaultXYPosition={{
              x: positionAbsoluteX,
              y: positionAbsoluteY,
            }}
            currentData={data}
          />
        )}
        placement="right"
        trigger="click"
      >
        {!isNodeForTriggerNode && (
          <NodeHandler
            type="target"
            position={Position.Top}
            nodeId={id}
          />
        )}
        <NodeHandler
          type="source"
          position={Position.Bottom}
          nodeId={id}
        />
        <Flex className={styles.container} onClick={() => setOpen(true)}>
          <PlusOutlined />
          <Typography.Text>
            {translate(`New #{${TranslationEntity.automation}} Block`, [{
              capitalize: true,
            }])}
          </Typography.Text>
        </Flex>
      </Popover>
    </>
  );
}
